import { PaytrieAPI } from '@paytrie/client'

import { SignUpStep } from '@/utils/signup'

type RequirementBuckets = Pick<
  PaytrieAPI.UserRequirements,
  'pending' | 'processing' | 'satisfied'
>

export const resolveStepFromRequirements = (
  requirements: RequirementBuckets
): SignUpStep | null => {
  const pending = new Set(requirements.pending)

  if (pending.size === 0) return null
  if (pending.has('emailVerification')) return 'email'
  if (pending.has('phoneVerification')) return 'phone'
  if (pending.has('personalInfo') || pending.has('address')) {
    return 'personal-info'
  }
  if (pending.has('occupation') || pending.has('disclosure')) {
    return 'occupation'
  }
  if (pending.has('additionalInfo')) return 'additional-info'
  if (pending.has('kyc')) return 'start-kyc'

  return null
}

export const hasPendingOnboarding = (
  requirements: RequirementBuckets
): boolean => requirements.pending.length > 0
